module.exports = __webpack_public_path__ + "static/img/16.5aa8406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/16.jpg
// module id = dxv1
// module chunks = 4